(function() {
    'use strict';
    angular.module('wbDashboard').directive('navigationAurea',
        ['$rootScope', '$transitions', '$window', '$location', '$timeout', '$uibModal', 'Auth', 'Account', 'User', 'PlanService',
            'Display', 'Session', 'Track', 'Login', 'CommonConstant', 'bugsnagClient',
    function ($rootScope, $transitions, $window, $location, $timeout, $uibModal, Auth, Account, User, PlanService,
              Display, Session, Track, Login, CommonConstant, bugsnagClient) {
        return {
            restrict: 'A',
            replace: true,
            scope: true,
            templateUrl: 'app/themes/aurea/directives/navigation/navigation.tpl.html',
            link: function (scope, element) {

                //hide the image behind the header only after this controller has loaded
                angular.element('header .space-holder .navbar-brand').addClass('invisible');

                let $navCollapse =  element.find('.navbar-collapse');

                scope.navData = {
                    show: true,
                    collapse: true,
                    showSettings: false,
                    isLoggedIn: false
                };

                scope.axos = {
                    isRedirect: false,
                    redirectUrl: null,
                    redirectGuid: null,
                };

                scope.openSupport = function() {
                    //unused,just email link now

                    var subject = `Desktop Support: (put issue topic here)`;
                    var message = encodeURIComponent(`How can we help you? 



Support Info:
User: ${scope.fullName},
Email: ${(scope.overview && scope.overview.user) ? scope.overview.user.email : ""},
Page: ${$location.path()}
`);

                    $window.open("mailto:"+ encodeURIComponent("support@axosinvest.com") + "?subject=" + subject+"&body="+message,"_blank");
                    bugsnagClient.notify({name:"User Support", message:"New Support Request"}, {
                        severity: 'info',
                    });
                    scope.navData.collapse = true;
                };

                scope.collapseNav = function() {
                    //prevent odd state where nav is collapsed but screen is resized
                    // and then overflow on body is still hidden
                    scope.navData.collapse = true;
                    scope.navData.showSettings = false;
                    $timeout(function() { scope.$apply(); });
                };
                angular.element($window).on('resize', scope.collapseNav);

                scope.blurClick = function($event) {
                    angular.element($event.currentTarget).blur();
                };

                var transitionDeregisterHook = $transitions.onBefore({}, function(trans) {
                    scope.navData.collapse = true;
                });
                scope.$on('$destroy', function() {
                    if (transitionDeregisterHook) {
                        transitionDeregisterHook();
                    }
                    angular.element($window).off('resize', scope.collapseNav);
                });

                $rootScope.$watch(function() { return Display.getMenu(); }, function(showMenu) {
                    if (showMenu !== null) {
                        scope.navData.show = showMenu;
                    }
                });

                $rootScope.$watch(function() { return User.get('overview'); }, function(overview) {
                    if (overview) {
                        scope.fullName = overview.user.first_name + " " + overview.user.last_name;
                        scope.initials = overview.user.first_name[0] + overview.user.last_name[0];
                        scope.foundingMember = overview.user.flags.founding_member;

                        scope.overview = overview;
                    }
                });

                $rootScope.$watch(function() { return User.getActivityPending(); }, function(activity) {
                    if (activity) {
                        scope.fundingNotificationCount = activity.length;
                    }
                });

                $rootScope.$watch(function() { return scope.navData.collapse; }, function(collapse) {
                    //this breaks scrolling of menu on iOS7
                    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                    var body = angular.element('body');
                    if (!scope.navData.collapse && !iOS) {
                        //don't scroll main page when menu is open
                        body.css('overflow', 'hidden');
                        if (   ($window.document.documentElement.clientHeight < $window.document.documentElement.scrollHeight)
                            || ($window.document.body.clientHeight < $window.document.body.scrollHeight)
                        ) {
                            //adjust scrollbars to prevent page jump
                            body.css('padding-right', getScrollBarWidth());
                            element.find('nav').addClass('show-scroll');
                        }
                    } else {
                        body.css('overflow', '');
                        body.css('padding-right', '');
                        element.find('nav').removeClass('show-scroll');
                    }
                });

                function getScrollBarWidth() {
                    var $outer = $('<div>').css({visibility: 'hidden', width: 100, overflow: 'scroll'}).appendTo('body'),
                        widthWithScroll = $('<div>').css({width: '100%'}).appendTo($outer).outerWidth();
                    $outer.remove();
                    return 100 - widthWithScroll;
                }

                scope.$watch( Auth.isLoggedIn, function ( isLoggedIn ) {
                    scope.navData.isLoggedIn = isLoggedIn;
                    if (scope.navData.isLoggedIn) {
                    }
                });

                scope.$watch( Auth.isAxosRedirect, function ( isAxosRedirect ) {
                    scope.axos.isRedirect = isAxosRedirect;
                    if (scope.isLoggedIn) {
                    }
                });

                scope.openAxosRedirect = function() {
                    scope.axos.redirectGuid = null;
                    scope.axos.redirectUrl = null;
                    Login.createAxosPropertyBag().then(function(bag) {
                        scope.axos.redirectGuid = bag;
                        scope.axos.redirectUrl = "https://onlinebanking.axosbank.com/auth/Dashboard?referrer=axos&referrer_token="+bag;
                        if (CommonConstant.devDomains.includes($location.host())) {
                            scope.axos.redirectUrl = "https://onlinebanking.uat.axosbank.com/auth/Dashboard?referrer=axos&referrer_token="+bag;
                        }

                    });

                    var modalInstance = $uibModal.open({
                        templateUrl: "axos-redirect-modal.tpl.html",
                        size: 'md',
                        scope: scope,
                        windowClass: 'axos-redirect-modal'
                    });
                    modalInstance.result.catch(angular.noop);
                };
            }
        };
    }]);
})();
